module.exports = __webpack_public_path__ + "img/MQ.420795d6.png";